import { render, staticRenderFns } from "./settlementProject.vue?vue&type=template&id=061aa66c&scoped=true&"
import script from "./settlementProject.vue?vue&type=script&lang=js&"
export * from "./settlementProject.vue?vue&type=script&lang=js&"
import style0 from "./settlementProject.vue?vue&type=style&index=0&id=061aa66c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061aa66c",
  null
  
)

export default component.exports